import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '../styles';
import { LessonType, routes, generateLessonQueryParams } from '@lean-body/src/route';
import { HeartIcon } from '../atoms/icons/heart_icon';
import { FireIcon } from '../atoms/icons/fire_icon';
import { ShadowHeartIcon } from '../atoms/icons/shadow_heart_icon';
import { RaderIcon } from '../atoms/icons/rader_icon';
import { useNavigate } from 'react-router-dom';
export const LessonComponent = ({ lesson, addFavoriteLesson, unFavoriteLesson, onClick, isVertical, isMin, isActive, disableHistoryPush, aboveName, isWhiteColor, courseDayLessonID, hideFavoriteButton, hideFavoriteCount, hideDifficulty, hideTags, hideDescription, classObject, headImgClassObject, }) => {
    const [isFavorited, setIsFavorited] = React.useState(lesson.isFavorite);
    const favoriteCount = lesson.lessonAggregate ? lesson.lessonAggregate.totalFavoriteCount.toLocaleString() : 0;
    const navigate = useNavigate();
    const clickFavorite = (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (isFavorited) {
            unFavoriteLesson(lesson.id);
            setIsFavorited(false);
        }
        else {
            addFavoriteLesson(lesson.id);
            setIsFavorited(true);
        }
    };
    const onClickHandler = (e) => {
        if (lesson.isDayOff) {
            e.stopPropagation();
            e.preventDefault();
        }
        else {
            if (onClick)
                onClick(lesson);
            if (!disableHistoryPush) {
                const url = routes.LESSON.compile({ type: LessonType.normal, slug: lesson.slug });
                const params = generateLessonQueryParams(courseDayLessonID);
                navigate(`${url}${params}`);
            }
        }
    };
    return (React.createElement("div", { className: css(styles.item, isMin && styles.itemMin, isVertical && styles.itemVertical, classObject), onClick: onClickHandler },
        React.createElement("div", { className: css(styles.headImg, isVertical && (isMin ? styles.headImgVerticalMin : styles.headImgVertical), headImgClassObject) },
            !lesson.isDayOff && !hideFavoriteButton && (React.createElement(ShadowHeartIcon, { color: Colors.White, filled: isFavorited, classObject: [styles.favoriteIconTopRight, isMin && styles.favoriteIconTopRightMin], onClick: clickFavorite })),
            !lesson.isDayOff && (React.createElement(React.Fragment, null, isActive ? (React.createElement(RaderIcon, { classObject: [styles.labelBottomRight, styles.rader, isMin && styles.labelBottomRightMin] })) : (React.createElement("div", { className: css(styles.labelBottomRight, styles.time, isMin && styles.labelBottomRightMin) }, `${lesson.duration}:00`)))),
            React.createElement("img", { className: css(styles.itemImg), src: lesson.thumbnailURL, loading: "lazy" })),
        React.createElement("div", { className: css(styles.itemDescription, isWhiteColor && styles.whiteColor) },
            aboveName,
            React.createElement("div", { className: css(styles.itemName, isVertical && styles.itemNameLarge, isMin && styles.itemNameMin) }, lesson.name),
            !lesson.isDayOff && (React.createElement("div", { className: css(styles.itemInfo, isVertical && styles.itemInfoLarge, isMin && styles.itemInfoMin) },
                !hideFavoriteCount && (React.createElement(React.Fragment, null,
                    React.createElement(HeartIcon, { classObject: [styles.favoriteIcon, isVertical && styles.favoriteIconLarge], color: isWhiteColor ? Colors.White : Colors.Black }),
                    favoriteCount)),
                !hideDifficulty && lesson.difficulty.name && `・${lesson.difficulty.name}`,
                !isMin && (React.createElement(React.Fragment, null,
                    (!hideFavoriteCount || !hideDifficulty) && '・',
                    React.createElement(FireIcon, { classObject: [styles.fireicon, isVertical && styles.fireiconLarge], color: isWhiteColor ? Colors.White : Colors.Black }),
                    React.createElement("span", null, `${lesson.minCal}-${lesson.maxCal}kcal`))))),
            isMin && isVertical && (React.createElement("div", { className: css(styles.itemInfo) },
                React.createElement(FireIcon, { classObject: [styles.fireicon, isVertical && styles.fireiconLarge], color: isWhiteColor ? Colors.White : Colors.Black }),
                React.createElement("span", null,
                    `${lesson.minCal}-${lesson.maxCal}kcal`,
                    lesson.pace.name && `・${lesson.pace.name}`))),
            !hideTags && !isMin && (React.createElement("div", { className: css(styles.itemTags) }, lesson.tags.map((v, i) => (React.createElement("div", { key: i, className: css(styles.itemTag) },
                "#",
                v.name))))),
            !hideDescription && !isMin && isVertical && React.createElement("div", { className: css(styles.desc) }, lesson.description))));
};
const styles = StyleSheet.create({
    item: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px 0',
        overflow: 'hidden',
        color: Colors.Black,
        cursor: 'pointer',
        width: '100%',
    },
    itemMin: {
        gap: '5px 0',
    },
    itemVertical: {
        flexDirection: 'row',
        gap: '0 10px',
    },
    headImg: {
        position: 'relative',
        flex: 1,
    },
    headImgVertical: {
        minWidth: 270,
        maxWidth: 335,
    },
    headImgVerticalMin: {
        minWidth: 160,
        maxWidth: 184,
    },
    labelBottomRight: {
        fontSize: 12,
        fontWeight: 'bold',
        letterSpacing: '0.04em',
        lineHeight: 1,
        borderRadius: 4,
        padding: '3px 4px',
        color: Colors.White,
        position: 'absolute',
        bottom: 6,
        right: 6,
    },
    rader: {
        backgroundColor: 'none',
    },
    time: {
        backgroundColor: Colors.Black,
    },
    labelBottomRightMin: {
        fontSize: 10,
    },
    favoriteIconTopRight: {
        width: 37,
        height: 33,
        position: 'absolute',
        top: 4,
        right: 4,
    },
    favoriteIconTopRightMin: {
        width: 34,
        height: 30,
        top: 3,
        right: 3,
    },
    itemDescription: {
        flex: 1,
    },
    whiteColor: {
        color: Colors.White,
    },
    itemImg: {
        aspectRatio: '16/9',
        width: '100%',
        borderRadius: 4,
        display: 'block',
    },
    itemName: {
        fontSize: 14,
        fontWeight: 'bold',
        lineHeight: '160%',
        letterSpacing: '0.04em',
        display: '-webkit-box',
        '-webkit-box-orient': 'vertical',
        '-webkit-line-clamp': '1',
        overflow: 'hidden',
    },
    itemNameMin: {
        fontSize: 12,
        '-webkit-line-clamp': '2',
    },
    itemNameLarge: {
        fontSize: 16,
    },
    itemInfo: {
        fontSize: 12,
        lineHeight: '160%',
        letterSpacing: '0.04em',
        display: 'flex',
        alignItems: 'center',
        margin: '2px 0',
    },
    itemInfoMin: {
        fontSize: 12,
    },
    itemInfoLarge: {
        fontSize: 14,
        fontWeight: 500,
    },
    favoriteIcon: {
        width: 12,
        height: 11,
        marginRight: 4,
    },
    favoriteIconLarge: {
        width: 15,
        height: 14,
    },
    fireicon: {
        width: 10,
        height: 14,
        margin: '0 4px 1px 0',
    },
    fireiconLarge: {
        width: 12,
        height: 16,
    },
    itemTags: {
        display: 'flex',
        flexWrap: 'wrap',
        height: 18,
        overflow: 'hidden',
    },
    itemTag: {
        marginRight: 6,
        fontSize: 12,
        color: Colors.GrayDarkest,
    },
    desc: {
        fontSize: 12,
        marginTop: 6,
        display: '-webkit-box',
        '-webkit-box-orient': 'vertical',
        '-webkit-line-clamp': '2',
        overflow: 'hidden',
    },
});
